<template>
  <div class="webview flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1 class="web-hidden">1on1navi: 幫助</h1>
            <h2>※ Help for Lite</h2>
            <div role="tablist">
              <b-card
                v-for="(help, idx) in getHelp"
                v-bind:key="'help'+idx"
              no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle="'help' + idx" variant="info">{{ help.head }}</b-btn>
                </b-card-header>
                <b-collapse :id="'help' + idx" accordion="helpAccordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text" v-html="help.body"></p>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.webview {
  overflow: auto;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
span.nth {
  margin-right: 0.5em;
}
ul.list-adjusted {
  padding-left: 1.5em;
}
.card-header .btn {
  white-space: normal;
  text-align: left;
}
</style>

<script>
import { willysm } from '@/main'
export default {
  name: 'LiteWebViewHelpsZHRe',
  data () {
    return {
      'helps': [
        {
          head: '【中】1on1naviの基本メニュー',
          body: '【中】（準備中）'
        },
        {
          head: '【中】プロフィールを編集する',
          body: '【中】 other＞Profileより、プロフィールの確認ができます。（右上の編集アイコン）より、プロフィールの項目を編集することができます。 　・今日のコンディション 　・ユーザー名 　・部署・役職 　・一言コメント 　・メール 　・電話番号 　・キャリアサマリ '
        },
        {
          head: '【中】ユーザーを検索する',
          body: '【中】other＞Peopleより、他のユーザーを検索することができます。ユーザー名を検索キーに入力して検索すると、・・・（要確認） '
        },
        {
          head: '【中】他のユーザーに関する情報を確認する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】OKRの一覧を確認する',
          body: '【中】 メニューのOKRを選択すると、OKRの一覧が表示されます。 Objectiveについて、進捗率、内容、期限、コメント数が表示され、その下にObjective に紐づくKey Resultの情報が表示されます。 ※Objectiveが登録されていないまたは全て完了している場合は空欄になります。 '
        },
        {
          head: '【中】OKRを登録する',
          body: '【中】 新規にObjectiveを登録する場合は、（右上の＋ボタン）を選択します。 Objective登録画面より、以下の項目を入力・選択して、（右上の保存ボタン）を選択することで登録が完了します。 　・内容 　・期限 　・公開設定：ユーザーまたはグループを選択します。選択しない場合は全ユーザーに公開されます。 　・進捗率 　・関連OKR：他のユーザーのObjectiveやKey Resultと、登録するObjectiveとの関連付けを行うことができます。（ユーザー検索方法は「ユーザーを検索する」を参照） 　Objectiveの登録後、続けてKey Resultの登録ができます。Key Resultの登録内容はObjectiveの登録内容と同じです。 　Key ResultはObjectiveの登録を終了した後でも登録することができます。OKRの一覧より、該当のObjectiveを選択してObjectiveの詳細よりKey Resultタブの「+Key Result」より追加できます。 '
        },
        {
          head: '【中】OKRを確認する',
          body: '【中】 OKRの一覧より、詳細を確認したいObjectiveまたはKey Resultを選択すると詳細が確認できます。 　・ユーザー名 　・作成日 　・内容 　・期限 　・公開 　・進捗率 　・Key Result　※Objectiveの場合のみタブ表示 　・コメント ・関連OKR　※関連OKRは他のユーザーが関連付けたOKRも表示されます。 '
        },
        {
          head: '【中】OKRを編集する・進捗率を変更する。',
          body: '【中】 OKRの一覧より、編集したいObjectiveまたはKey Resultを選択すると詳細が表示されます。（右上の…ボタン）を選択後、Objective編集（Key Result編集）を選択すると、Objective（Key Result）を編集することができます。 Objective（Key Result）の進捗率についてはObjective（Key Result）の詳細からでも変更することができます。 （編集できる項目は「OKRを登録する」を参照） '
        },
        {
          head: '【中】OKRを削除する',
          body: '【中】 OKRの一覧より、削除したいObjectiveまたはKey Resultを選択すると詳細が表示されます。（右上の…ボタン）を選択後、削除を選択すると、Objective（Key Result）は削除されます。Objectiveを削除した場合は、そのObjectiveに紐づくKey Resultも削除されます。 '
        },
        {
          head: '【中】OKRを完了する',
          body: '【中】 OKRの一覧より、完了させたいObjectiveまたはKey Resultを選択すると詳細が表示されます。（右上の…ボタン）を選択後、完了を選択すると、Objective（Key Result）が完了した状態となります。 ・Objectiveを完了させると、OKRの一覧から表示されなくなります。完了したObjectiveは「完了OKR」メニューより確認できます。 ・Key Resultを完了させると、OKRの一覧やObjectiveの詳細では、Key Resultに完了したことを示すチェックマークが表示されます。 ※Objectiveを完了させると、紐づくKey Resultが完了されていなくても全て完了扱いとしてOKRの一覧から表示されなくなります。 '
        },
        {
          head: '【中】完了OKRを確認する',
          body: '【中】 OKRの（左上のメニューボタン）より、「完了OKR」を選択すると完了したObjectiveが一覧で表示されます。ObjectiveまたはKey Resultを選択すると詳細の確認ができます。 '
        },
        {
          head: '【中】完了したObjectiveをOKRの一覧に戻す',
          body: '【中】 OKRの（左上のメニューボタン）より、「完了OKR」を選択すると完了したObjectiveが一覧で表示されます。OKRの一覧に戻したいObjectiveを選んで（右上の…ボタン）を選択した後、「未完了に戻す」を選択すると「完了OKR」からOKRの一覧に戻ります。 '
        },
        {
          head: '【中】完了したKey Resultを未完了に戻す',
          body: '【中】 OKRの一覧からKey Resultを選択する、もしくはObjectiveを選択してObjectiveの詳細からKey Resultを選択してKey Resultの詳細を表示させて、（右上の…ボタン）を選択し、「未完了に戻す」を選択すると、OKRの一覧やObjectiveの詳細のKey Resultについていた完了チェックマークが消えます。 '
        },
        {
          head: '【中】OKRの一覧に表示されているObjectiveの並び順を変更する',
          body: '【中】 OKRの（左上のメニューボタン）より、「並び順設定」を選択すると以下より表示順を選択できます。 　・登録日時（降順） 　・登録日時（昇順） 　・更新日時（降順） 　・更新日時（昇順） '
        },
        {
          head: '【中】Objective（Key Result）の関連OKRを削除する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】1on1の内容を確認する',
          body: '【中】 1on1メニューを選択すると、これまでの1on1の内容が表示されます。表示内容は以下の通りです。 　・日付 　・サマリー 　・誇れること 　・気づき 　・次へのアクション 日付以外の項目の表示領域を選択すると、各内容の詳細が表示されます。 ※日付の右にある（本のアイコン）を選択すると、個人メモが確認・編集できます。 '
        },
        {
          head: '【中】1on1の内容を登録する',
          body: '【中】 1on1メニューを選択し、（右上の＋ボタン）を選択すると、新規の1on1の内容を登録することができます。登録する内容は以下の通りです。 　・日付 　・公開範囲設定 　・サマリー 　・誇れること 　・気づき 　・次へのアクション 　・個人用メモ　※公開されません '
        },
        {
          head: '【中】1on1の内容を編集する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】1on1の内容に個人用メモをつける',
          body: '【中】 1on1メニューを選択し、1on1の日付の横にある（本のアイコン）を選択すると、メモ画面が表示され、個人用メモを書き込むことができます。また、1on1の各項目詳細を表示させて（右上の…ボタン）を選択して、個人用メモを登録・編集することもできます。 '
        },
        {
          head: '【中】1on1リクエストを送信する',
          body: '【中】 1on1メニューを選択し、（左上のメールマーク）を選択すると、1on1リクエストをかけることができます。「送信先」より対象ユーザーを選択し、コメントを入力したうえで送信ボタンを選択すると、送信先のユーザーにリクエストの通知が届きます。 '
        },
        {
          head: '【中】1on1リクエストした履歴を確認する',
          body: '【中】 1on1メニューを選択し、（左上のメールマーク）を選択して、1on1リクエストを表示させ、右上の履歴ボタンを選択すると、これまでのリクエストの送信履歴が確認できます。 '
        },
        {
          head: '【中】リアルタイムフィードバックをみる',
          body: '【中】 rtfbメニューを選択すると、これまでのリアルタイムフィードバックへの投稿内容が確認できます。 ・ユーザー名 ・投稿日時 ・投稿内容 ・コメント数 ・いいね数 投稿されているフィードバックを選択すると、リアルタイムフィードバックの詳細が表示され、フィードバックコメントのやりとりやいいねを押したユーザー一覧が確認できます。 '
        },
        {
          head: '【中】リアルタイムフィードバックを投稿する',
          body: '【中】 rtfbメニューを選択し、リアルタイムフィードバック一覧の（右上の＋ボタン）を選択するとリアルタイムフィードバックへの投稿ができます。 ・公開設定 ・内容 ・ファイル添付 '
        },
        {
          head: '【中】投稿したリアルタイムフィードバックを編集する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】投稿したリアルタイムフィードバックを削除する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】グループを作成する',
          body: '【中】 グループを作成することで、公開範囲をグループに登録されているユーザーに設定することができます。okr、1on1、リアルタイムフィードバックで利用することができます。 other＞peopleより、グループの右にある＋を選択して、グループ名を記入します。 グループ作成画面でメンバーの右にある＋を選択して、ユーザーを検索し、追加するユーザーが表示されたら選択します（チェックがつきます）。左上の＜ボタンを押すとグループメンバー候補に追加されます。以上のユーザー検索・選択を繰り返してグループメンバーを選び終わったら、右上の完了ボタンを選択するとグループが作成され、グループ一覧に追加されます。 ※グループには予めユーザー自身が含まれており、グループ一覧のメンバー数にカウントされています。 '
        },
        {
          head: '【中】グループメンバーの追加・変更・削除をおこなう。',
          body: '【中】（準備中）'
        },
        {
          head: '【中】グループ名を編集する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーのobjectiveやkey resultにコメントする',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーの1on1の内容にコメントする',
          body: '【中】（準備中）'
        },
        {
          head: '【中】コメントを削除する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーのリアルタイムフィードバックへの投稿にコメントする',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーのリアルタイムフィードバックへの投稿にいいねをつける',
          body: '【中】（準備中）'
        },
        {
          head: '【中】コメントにファイルを添付する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーのアクションに関する通知を受け取れるようにする',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーのアクションに関する通知設定を解除する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーのアクションに関する通知内容を確認する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】他ユーザーからの1on1リクエストの受信を確認する',
          body: '【中】（準備中）'
        },
        {
          head: '【中】ログアウトする',
          body: '【中】（準備中）'
        }
      ]
    }
  },
  computed: {
    getHelp () {
      let help = this.helps
      if (!willysm.enabled) {
        // 後ろから一つ前に追記する
        help[help.length - 2] = {
          head: `コンディションを変更する`,
          body: `
  画面左上のプロフィールで、お天気マークをクリックすることにより変更されます。<br><br>
  `
        }
      }
      return help
    }
  }
}
</script>
<style scoped>
  .web-hidden{
    display: none;
  }
  .p-1{
   padding: 0.5rem !important;
   transition: 0.2s all;
  }
  .card-header .btn{
    margin-top: 0;
  }
  .btn-info{
    background-color: #ffffff;
    border-color: #fcfcfc;
    padding: 0.8rem 1rem;
  }
  .btn-info:hover,.btn-info:focus, .btn-info.focus {
    color: #fff;
    background-color: #39b2d5;
    box-shadow: none;
  }
  .mb-1, .my-1{
    margin-bottom: 0.5rem !important;
  }
  .card-body, .card-block{
    padding: 1.5rem 1.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/_webview/LiteWebViewHelpsZHRe.vue